
import { defineComponent, reactive } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'

// realisations

// types

// validation
import useVuelidate from '@vuelidate/core'

// composable
import { required } from '@vuelidate/validators'

export default defineComponent({
    components: {
        modal: Modal,
        'the-input': TheInput,
    },
    emits: ['create', 'cancel'],
    setup(props, { emit }) {
        const state = reactive({
            is_loading: false,

            act_number: null as string | null,
            act_date: null as string | null,
        })

        const CreateRPPValidation = {
            act_number: { required },
            act_date: { required },
        }

        const state_form$ = useVuelidate(CreateRPPValidation, state)

        const emitCancel = () => {
            emit('cancel')
        }

        const emitCreateOrder = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('create', state.act_number, state.act_date)
        }

        return {
            state,
            state_form$,
            emitCancel,
            emitCreateOrder,
        }
    },
})
